export const TOP_NAV_HEIGHT = 52

export const SIDEBAR_WIDTH_EXPANDED = '14rem' // w-56
export const SIDEBAR_WIDTH_COLLAPSED = '4rem' // w-16

export function clientPageInset(isCollapsed) {
  return isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED
}

export const CLIENT_PAGE_GUTTER = 'px-8'
